/* BlankStyl Theme JS */
(function(){
  'use strict';

  /* ── STICKY NAV ── */
  var nav = document.getElementById('site-nav');
  if(nav){
    function onScroll(){ nav.classList.toggle('stuck', window.scrollY > 44); }
    window.addEventListener('scroll', onScroll, {passive:true});
    onScroll();
  }

  /* ── SCROLL REVEALS ── */
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, {threshold:0.12});
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }

  /* ── RABBIT DRAW ON SCROLL ── */
  if('IntersectionObserver' in window){
    var io2 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('scrawl-active'); io2.unobserve(e.target); }
      });
    }, {threshold:0.25});
    document.querySelectorAll('.bs-canvas').forEach(function(c){ io2.observe(c); });
  } else {
    document.querySelectorAll('.bs-canvas').forEach(function(c){ c.classList.add('scrawl-active'); });
  }

  /* ── COUNTDOWN ── */
  var cd = document.getElementById('bs-countdown');
  if(cd){
    var raw = cd.dataset.launch || '';
    var target = raw ? new Date(raw).getTime() : Date.now() + 14*864e5;
    var els = {
      d: document.getElementById('cd-d'),
      h: document.getElementById('cd-h'),
      m: document.getElementById('cd-m'),
      s: document.getElementById('cd-s')
    };
    function pad(n){ return String(Math.max(0,n)).padStart(2,'0'); }
    function tick(){
      var diff = Math.max(0, target - Date.now());
      var D = Math.floor(diff/864e5); diff -= D*864e5;
      var H = Math.floor(diff/36e5);  diff -= H*36e5;
      var M = Math.floor(diff/6e4);   diff -= M*6e4;
      var S = Math.floor(diff/1e3);
      if(els.d) els.d.textContent = pad(D);
      if(els.h) els.h.textContent = pad(H);
      if(els.m) els.m.textContent = pad(M);
      if(els.s) els.s.textContent = pad(S);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ── EMAIL / WAITLIST SIGNUP ── */
  window.bsSignup = function(){
    var inp = document.getElementById('bs-email-input');
    var form = document.getElementById('bs-email-form');
    var succ = document.getElementById('bs-email-success');
    if(!inp) return;
    var v = (inp.value || '').trim();
    if(!v.includes('@') || v.split('@')[1].indexOf('.') < 1){
      inp.style.borderColor = '#e25555';
      inp.focus();
      setTimeout(function(){ inp.style.borderColor = ''; }, 1600);
      return;
    }
    if(form) form.style.display = 'none';
    if(succ) succ.style.display = 'block';
    /* TODO: POST to Klaviyo list subscribe endpoint */
  };
  var ei = document.getElementById('bs-email-input');
  if(ei) ei.addEventListener('keydown', function(e){ if(e.key==='Enter') window.bsSignup(); });

  /* ── FAQ ACCORDION ── */
  document.querySelectorAll('.cs-faq-q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('.cs-faq-item');
      var ans  = item.querySelector('.cs-faq-a');
      var open = item.classList.toggle('open');
      ans.style.maxHeight = open ? ans.scrollHeight + 'px' : '0';
    });
  });

  /* ── CONTACT FORM ── */
  window.bsContactSend = function(){
    var email = document.querySelector('.cs-cform [name=email]');
    var msg   = document.querySelector('.cs-cform [name=message]');
    var bad = false;
    [email, msg].forEach(function(el){
      if(!el || !el.value.trim()){
        if(el){ el.style.borderColor='#e25555'; setTimeout(function(){ el.style.borderColor=''; },1600); }
        bad = true;
      }
    });
    if(bad) return;
    var f  = document.getElementById('bs-contact-form');
    var ok = document.getElementById('bs-contact-success');
    if(f) f.style.display = 'none';
    if(ok) ok.style.display = 'block';
    /* TODO: POST to Shopify contact form or email service */
  };

})();
